// src/pages/deliveryNote/DeliveryNoteA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { getImageUrl } from '../../utils/imageUtils';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';

const DeliveryNoteA4Document = ({ deliveryNote, itemNames = {} }) => {
  const { t } = useLocalization();

  if (!deliveryNote) return null;

  return (
    <A4DocumentLayout
      title={t('deliveryNote.deliveryNoteNumber')}
      logoUrl={getImageUrl(deliveryNote.order?.Shop?.logo)}
      subtitle={t('deliveryNote.officialDeliveryNote', 'Official Delivery Note')}
      documentNumber={`#${deliveryNote.deliveryNoteNumber}`}
      metaRows={[
        { label: t('common.created'), value: new Date(deliveryNote.createdAt).toLocaleString() },
        { label: t('common.status'), value: (deliveryNote.status || '').toUpperCase() },
      ]}
      infoCards={[
        {
          title: t('deliveryNote.orderNumber'),
          primary: `#${deliveryNote.order?.orderNumber || t('common.na')}`,
          lines: [`${t('deliveryNote.deliveredAt')}: ${deliveryNote.deliveredAt ? new Date(deliveryNote.deliveredAt).toLocaleString() : t('common.na')}`],
        },
        {
          title: t('deliveryNote.receivedByName'),
          lines: [deliveryNote.receivedByName || t('common.na')],
        },
      ]}
      items={{
        columns: [
          { header: '#', align: 'center', width: '40px' },
          { header: t('deliveryNote.item') },
          { header: t('deliveryNote.quantityDelivered'), align: 'center' },
        ],
        rows: (deliveryNote.items || []).map((item, index) => [
          index + 1,
          <strong>{itemNames[item.orderItemId]?.name || `${t('deliveryNote.item')} #${item.orderItemId}`}</strong>,
          item.quantityDelivered,
        ]),
      }}
      summary={deliveryNote.notes ? { notes: { label: t('deliveryNote.notes'), text: deliveryNote.notes } } : undefined}
      footerNote="This is a computer-generated delivery note."
    />
  );
};

export default DeliveryNoteA4Document;
